module.exports = __webpack_public_path__ + "static/media/infections@2x.d16ae0a8.png";